/**
 * 都道府県マスタ（制覇マップ用）
 *
 * バックエンドの Place.prefecture は逆ジオコーディング結果の文字列なので、
 * 「東京」「東京都」のような表記ゆれを正規化して突き合わせる。
 */

export type Region = {
  name: string
  prefectures: string[]
}

export const REGIONS: Region[] = [
  { name: '北海道', prefectures: ['北海道'] },
  { name: '東北', prefectures: ['青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県'] },
  { name: '関東', prefectures: ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県'] },
  {
    name: '中部',
    prefectures: ['新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県'],
  },
  { name: '近畿', prefectures: ['三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県'] },
  { name: '中国', prefectures: ['鳥取県', '島根県', '岡山県', '広島県', '山口県'] },
  { name: '四国', prefectures: ['徳島県', '香川県', '愛媛県', '高知県'] },
  {
    name: '九州・沖縄',
    prefectures: ['福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'],
  },
]

export const ALL_PREFECTURES: string[] = REGIONS.flatMap((r) => r.prefectures)

export const TOTAL_PREFECTURE_COUNT = ALL_PREFECTURES.length

/** 「東京」「東京都」どちらでも同じキーになるよう末尾の 都/道/府/県 を落とす */
export const normalizePrefecture = (name: string): string => name.replace(/[都道府県]$/, '')

/** 地図ラベル用の短縮名（「神奈川県」→「神奈川」、「北海道」はそのまま） */
export const shortPrefectureName = (name: string): string => (name === '北海道' ? name : normalizePrefecture(name))
